import { DEFAULT_LOCALE } from '@/lib/constants/i18n';
import { useStore } from './useStore';

const useCurrentLocale = () =>
  useStore(
    (state) => state.locale || state.partner?.defaultLocale || DEFAULT_LOCALE,
  );

export default useCurrentLocale;
